<script setup lang="ts">
const router = useRouter()
const { $bus } = useNuxtApp()

const goToCombo = () => {
    $bus.$emit('update:only-combo', true)
    router.push('/store?only_combo=true')
}
</script>
<template>
    <q-btn color="primary" flat class="tw-w-max md:tw-bg-primary tw-rounded-full tw-h-10 tw-min-w-max tw-capitalize
            tw-font-titilium tw-font-bold !tw-border-0 tw-text-xs sm:tw-text-base md:!tw-text-white"
        @click="goToCombo">
        <q-icon name="sym_o_local_mall" size="16px" />
        <q-item-label class="tw-px-auto tw-mx-1">{{ $t('combos.title') }}</q-item-label>
    </q-btn>
</template>